var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-main"},[(_vm.loadingShow)?_c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"loading-notice"},[_vm._v(_vm._s(_vm.font))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }